var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreaditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5453_33930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 12C11 12.394 11.0776 12.7841 11.2284 13.1481C11.3791 13.512 11.6001 13.8427 11.8787 14.1213C12.1573 14.3999 12.488 14.6209 12.8519 14.7716C13.2159 14.9224 13.606 15 14 15C14.394 15 14.7841 14.9224 15.1481 14.7716C15.512 14.6209 15.8427 14.3999 16.1213 14.1213C16.3999 13.8427 16.6209 13.512 16.7716 13.1481C16.9224 12.7841 17 12.394 17 12C17 11.606 16.9224 11.2159 16.7716 10.8519C16.6209 10.488 16.3999 10.1573 16.1213 9.87868C15.8427 9.6001 15.512 9.37913 15.1481 9.22836C14.7841 9.0776 14.394 9 14 9C13.606 9 13.2159 9.0776 12.8519 9.22836C12.488 9.37913 12.1573 9.6001 11.8787 9.87868C11.6001 10.1573 11.3791 10.488 11.2284 10.8519C11.0776 11.2159 11 11.606 11 12Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 9.765C11.5687 9.3786 11.0345 9.12539 10.4622 9.03597C9.88984 8.94654 9.30387 9.02472 8.77501 9.26106C8.24615 9.4974 7.79703 9.8818 7.48188 10.3678C7.16673 10.8539 6.99902 11.4207 6.99902 12C6.99902 12.5793 7.16673 13.1461 7.48188 13.6322C7.79703 14.1182 8.24615 14.5026 8.77501 14.7389C9.30387 14.9753 9.88984 15.0535 10.4622 14.964C11.0345 14.8746 11.5687 14.6214 12.0002 14.235",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5453_33930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreaditcard);
export default __webpack_public_path__ + "static/media/Creaditcard.b0c8d75fda17592ea8a2e96df4c9308b.svg";
export { ForwardRef as ReactComponent };